import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_PLAYERS_FETCH = 'TRN_PLAYERS_FETCH'
export const TRN_PLAYERS_FETCH_CANCELED = 'TRN_PLAYERS_FETCH_CANCELED'
export const TRN_PLAYERS_FETCH_ERROR = 'TRN_PLAYERS_FETCH_ERROR'
export const TRN_PLAYERS_FETCH_FULFILLED = 'TRN_PLAYERS_FETCH_FULFILLED'

export const playersFetch = (payload) => ({
  payload,
  type: TRN_PLAYERS_FETCH,
})

export const playersFetchFulfilled = (payload) => ({
  payload,
  type: TRN_PLAYERS_FETCH_FULFILLED,
})

export const playersFetchCanceled = () => ({
  payload: null,
  type: TRN_PLAYERS_FETCH_CANCELED,
})

export const playersFetchError = (payload) => ({
  payload,
  type: TRN_PLAYERS_FETCH_ERROR,
})

export const playersFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_PLAYERS_FETCH),
    mergeMap((action) =>
      epicServerRequest('get', `${APP.api_url}/sports/tournament/${action.payload}/players`, action).pipe(
        map(epicResponseHandler(playersFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_PLAYERS_FETCH, TRN_PLAYERS_FETCH_CANCELED))),
        catchError(epicErrorHandler(playersFetchError, action)),
      ),
    ),
  )
